/**
 * Debug logging utility
 * Only logs in development mode to avoid performance overhead in production
 */
const DEBUG = process.env.NODE_ENV === 'development';

export const debugLog = {
  canvas: (...args: any[]) => {
    if (DEBUG) {
      console.log('[Canvas Debug]', ...args);
    }
  },
  warn: (...args: any[]) => {
    if (DEBUG) {
      console.warn('[Canvas Debug]', ...args);
    }
  },
};

